/* eslint-disable no-unused-vars */
import React from "react";
import Layout from "./Layout";
import { Link } from "react-router-dom";

function Speaker() {
  return (
    <div>
      <section
        id="line-up"
        className="lineup-section lineup-2 subscription-2 pt-40 pb-100 pt-lg-120 pb-lg-150 mb-20"
      >
        <div className="container" id="Speakers">
          <div className="row gx-60 gx-xxl-80 gy-30 align-items-center">
            <div className="col-lg-4">
              <div className="lineup-right-content mt-3 mt-lg-0">
                <div className="section-title mb-4 mb-lg-30 mb-xxl-40">
                  <span className="fs-3 straight-line-wrapper fw-semibold position-relative">
                    <span className="straight-line" />
                    Team
                  </span>
                  <h2 className="title display-3 fw-extra-bold d-flex flex-column">
                    <span className="mb-n2 text-opacity">Meet The </span>
                    <span className="sub-title fw-extra-bold text-primary">
                      Speakers
                    </span>
                  </h2>
                </div>
                {/* section-title */}
                <p className="custom-jakarta custom-font-style-2 mb-4 mb-lg-30">
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry. Lorem Ipsum has been the industry's
                  standard dummy text ever since the 1500s, .
                </p>
                <div className="py-2 pb-lg-0 pt-lg-3">
                  <Link
                    to="#"
                    className="download-link d-flex align-items-center gap-30"
                    aria-label="buttons"
                  >
                    See More
                    <span className="ticket-arrow arrow-up-right">
                      <svg width={32} height={32}>
                        <use xlinkHref="#arrow-up-right" />
                      </svg>
                    </span>
                  </Link>
                </div>
              </div>
              {/* lineup-right-content */}
            </div>
            {/* col-5 */}
            <div className="col-lg-8">
              <div className="swiper-custom-progress position-relative">
                <div className="swiper lineup-swiper">
                  <div className="swiper-wrapper">
                    <div className="swiper-slide">
                      <div className="lineup-image-wrapper position-relative">
                        <div className="lineup-image">
                          <img
                            src="assets/images/pic.png"
                            className="img-fluid"
                            alt="lineup-image"
                          />
                        </div>
                        <div className="lineup-image-hover">
                          <p className="author-name">Lorem Ipsum</p>
                          <div className="line-up-hover-content">
                            <h5 className="fw-medium mb-20">
                              Lorem Ipsum :{" "}
                              <span className>
                                Lorem Ipsum is simply dummy text of the printing
                                and typesetting industry. Lorem Ipsum is simply
                                dummy text of the printing and typesetting
                                industry. Lorem Ipsum is simply dummy text.{" "}
                              </span>
                            </h5>
                            {/* <div className="line-up-icons d-flex align-items-center gap-3 gap-lg-20">
                                <a
                                  href="#"
                                  className="facebook-icon"
                                  aria-label="facebook"
                                >
                                  <svg width={20} height={20}>
                                    <use xlinkHref="#facebook-icon" />
                                  </svg>
                                </a>
                                <a
                                  href="#"
                                  className="instagram-icon"
                                  aria-label="instagram"
                                >
                                  <svg width={20} height={20}>
                                    <use xlinkHref="#instagram-icon" />
                                  </svg>
                                </a>
                                <a
                                  href="#"
                                  className="youtube-icon"
                                  aria-label="youtube"
                                >
                                  <svg width={20} height={20}>
                                    <use xlinkHref="#youtube-icon" />
                                  </svg>
                                </a>
                                {/* <a
                                  href="#"
                                  className="spotify-icon"
                                  aria-label="spotify"
                                >
                                  <svg width={20} height={20}>
                                    <use xlinkHref="#spotify-icon" />
                                  </svg>
                                </a> */}
                            {/* </div>  */}
                          </div>
                        </div>
                        {/* lineup-image-hover */}
                      </div>
                      {/* lineup-image-wrapper */}
                    </div>
                    {/* swiper-slide*/}
                    <div className="swiper-slide">
                      <div className="lineup-image-wrapper position-relative">
                        <div className="lineup-image">
                          <img
                            src="assets/images/pic.png"
                            className="img-fluid"
                            alt="lineup-image"
                          />
                        </div>
                        <div className="lineup-image-hover">
                          <p className="author-name">Lorem Ipsum</p>
                          <div className="line-up-hover-content">
                            <h5 className="fw-medium mb-20">
                              Genere :{" "}
                              <span className>
                                Lorem Ipsum is simply dummy text of the printing
                                and typesetting industry. Lorem Ipsum is simply
                                dummy text of the printing and typesetting
                                industry. Lorem Ipsum is simply dummy text.{" "}
                              </span>
                              {/* <span className="text-uppercase">Lorem Ipsum</span> */}
                            </h5>
                          </div>
                        </div>
                        {/* lineup-image-hover */}
                      </div>
                      {/* lineup-image-wrapper */}
                    </div>
                    {/* swiper-slide*/}
                    <div className="swiper-slide">
                      <div className="lineup-image-wrapper position-relative">
                        <div className="lineup-image">
                          <img
                            src="assets/images/pic.png"
                            className="img-fluid"
                            alt="lineup-image"
                          />
                        </div>
                        <div className="lineup-image-hover">
                          <p className="author-name">Lorem Ipsum</p>
                          <div className="line-up-hover-content">
                            <h5 className="fw-medium mb-20">
                              Genere :{" "}
                              <span className>
                                Lorem Ipsum is simply dummy text of the printing
                                and typesetting industry. Lorem Ipsum is simply
                                dummy text of the printing and typesetting
                                industry. Lorem Ipsum is simply dummy text.{" "}
                              </span>
                            </h5>
                          </div>
                        </div>
                        {/* lineup-image-hover */}
                      </div>
                      {/* lineup-image-wrapper */}
                    </div>
                    {/* swiper-slide*/}
                    <div className="swiper-slide">
                      <div className="lineup-image-wrapper position-relative">
                        <div className="lineup-image">
                          <img
                            src="assets/images/pic.png"
                            className="img-fluid"
                            alt="lineup-image"
                          />
                        </div>
                        <div className="lineup-image-hover">
                          <p className="author-name">Lorem Ipsum</p>
                          <div className="line-up-hover-content">
                            <h5 className="fw-medium mb-10">
                              Genere :{" "}
                              <span className>
                                Lorem Ipsum is simply dummy text of the printing
                                and typesetting industry. Lorem Ipsum is simply
                                dummy text of the printing and typesetting
                                industry. Lorem Ipsum is simply dummy text.{" "}
                              </span>
                            </h5>
                          </div>
                        </div>
                        {/* lineup-image-hover */}
                      </div>
                      {/* lineup-image-wrapper */}
                    </div>
                    {/* swiper-slide*/}
                    <div className="swiper-slide">
                      <div className="lineup-image-wrapper position-relative">
                        <div className="lineup-image">
                          <img
                            src="assets/images/pic.png"
                            className="img-fluid"
                            alt="lineup-image"
                          />
                        </div>
                        <div className="lineup-image-hover">
                          <p className="author-name">Lorem Ipsum</p>
                          <div className="line-up-hover-content">
                            <h5 className="fw-medium mb-20">
                              Genere :{" "}
                              <span className>
                                Lorem Ipsum is simply dummy text of the printing
                                and typesetting industry. Lorem Ipsum is simply
                                dummy text of the printing and typesetting
                                industry. Lorem Ipsum is simply dummy text.{" "}
                              </span>
                            </h5>
                          </div>
                        </div>
                        {/* lineup-image-hover */}
                      </div>
                      {/* lineup-image-wrapper */}
                    </div>
                    {/* swiper-slide*/}
                    <div className="swiper-slide">
                      <div className="lineup-image-wrapper position-relative">
                        <div className="lineup-image">
                          <img
                            src="assets/images/pic.png"
                            className="img-fluid"
                            alt="lineup-image"
                          />
                        </div>
                        <div className="lineup-image-hover">
                          <p className="author-name">Lorem Ipsum</p>
                          <div className="line-up-hover-content">
                            <h5 className="fw-medium mb-20">
                              Genere :{" "}
                              <span className="text-uppercase">
                                Lorem Ipsum is simply dummy text of the printing
                                and typesetting industry. Lorem Ipsum is simply
                                dummy text of the printing and typesetting
                                industry. Lorem Ipsum is simply dummy text.{" "}
                              </span>
                            </h5>
                            {/* <div className="line-up-icons d-flex align-items-center gap-3 gap-lg-20">
                                  <a
                                    href="#"
                                    className="facebook-icon"
                                    aria-label="facebook"
                                  >
                                    <svg width={20} height={20}>
                                      <use xlinkHref="#facebook-icon" />
                                    </svg>
                                  </a>
                                  <a
                                    href="#"
                                    className="instagram-icon"
                                    aria-label="instagram"
                                  >
                                    <svg width={20} height={20}>
                                      <use xlinkHref="#instagram-icon" />
                                    </svg>
                                  </a>
                                  <a
                                    href="#"
                                    className="youtube-icon"
                                    aria-label="youtube"
                                  >
                                    <svg width={20} height={20}>
                                      <use xlinkHref="#youtube-icon" />
                                    </svg>
                                  </a>
                                  {/* <a
                                  href="#"
                                  className="spotify-icon"
                                  aria-label="spotify"
                                >
                                  <svg width={20} height={20}>
                                    <use xlinkHref="#spotify-icon" />
                                  </svg>
                                </a> */}
                            {/* </div> */}
                          </div>
                        </div>
                        {/* lineup-image-hover */}
                      </div>
                      {/* lineup-image-wrapper */}
                    </div>
                    {/* swiper-slide*/}
                  </div>
                  {/* swiper-wrapper */}
                </div>
                {/* swiper */}
                <div
                  className="lineup-swiper-pagination"
                  style={{
                    position: "relative",
                    top: "20px", // Moves the pagination line below the image
                  }}
                />
                <div className="swiper-button-progress">
                  <div className="swiper-button-next">
                    <span className="chevron-right-icon">
                      <svg width={12} height={14}>
                        <use xlinkHref="#chevron-right-icon" />
                      </svg>
                    </span>
                  </div>
                  <div className="swiper-button-prev">
                    <span className="chevron-left-icon">
                      <svg width={12} height={14}>
                        <use xlinkHref="#chevron-left-icon" />
                      </svg>
                    </span>
                  </div>
                </div>
                <div className="ellipse-image-5">
                  <img
                    src="assets/images/ellipse-5.png"
                    className="img-fluid"
                    alt="img"
                  />
                </div>
              </div>
            </div>
            {/* col-7 */}
          </div>
          {/* row */}
        </div>
        {/* container */}
      </section>
    </div>
  );
}

export default Speaker;
